import React from "react";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import MapIcon from "../../../images/contact-us/map.svg";
import "./ContactUsMainAddressWidget.css";

const ContactUsMainAddressWidget = () => (
    <WidgetContainer stylesClass="cu-address">
        <div className="cu-address__postal">
            <div className="cu-address__postal__item">
                <h2>
                    Registered <br className="contact-bar" /> Address
                </h2>
                <span className="adress-bar"></span>

                <div className="cu-address__postal__item__address">
                    <ul>
                        <li>Phonepe Private Limited</li>
                        <li>(Formerly known as FX Mart Private Ltd. ), </li>
                        <li>Unit No.001, Ground Floor, Boston House, </li>
                        <li>Suren Road, Off. Andheri-Kurla Road,</li>
                        <li>Andheri(East) Mumbai-400093, Maharashtra,India</li>
                    </ul>
                </div>
                <div className="cu-address__postal__item__adpin">
                    <img
                        src={MapIcon}
                        width="24"
                        height="39"
                        alt="Map Pin Icon"
                    />
                    <a
                        href="https://www.google.com/maps/place/Boston+House,+Prakashwadi+Rd,+Chakala,+Andheri+East,+Mumbai,+Maharashtra+400053/@19.1169589,72.8543678,17z/data=!3m1!4b1!4m8!1m2!2m1!1sPhonepe+Mumbai+office+boston+house+map!3m4!1s0x3be7c8320fb16087:0xea42d8c18fa8ff89!8m2!3d19.1169538!4d72.8565565"
                        target="_blank"
                    >
                        View in Maps
                    </a>
                </div>
            </div>

            <div className="cu-address__postal__item">
                <h2>
                    Mailing <br className="contact-bar" /> Address
                </h2>
                <span className="adress-bar"></span>

                <div className="cu-address__postal__item__address">
                    <ul>
                        <li>Ashford Park View,</li>
                        <li> Site No – 9 Industrial Layout,</li>
                        <li>Koramangala 3rd Block,80 ft Road,</li>
                        <li> Bangalore-560034</li>
                    </ul>
                </div>
                <div className="cu-address__postal__item__adpin">
                    <img
                        src={MapIcon}
                        width="24"
                        height="39"
                        alt="Map Pin Icon"
                    />
                    <a
                        href="https://www.google.com/maps/place/PhonePe/@12.9354141,77.6303575,12z/data=!4m8!1m2!2m1!1sPhonePe+Private+Limited!3m4!1s0x3bae15fc269d573f:0x2f70a76f92803fd0!8m2!3d12.9287274!4d77.6329632?hl=en-US"
                        target="_blank"
                    >
                        View in Maps
                    </a>
                </div>
            </div>
            <div className="cu-address__postal__embedded-map cu-address__postal__item">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d124434.20081997031!2d77.6303575!3d12.9354141!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15fc269d573f%3A0x2f70a76f92803fd0!2sPhonePe!5e0!3m2!1sen!2sin!4v1589282495765!5m2!1sen!2sin"
                    frameborder="0"
                ></iframe>
            </div>
        </div>
        <div className="cu-address__hr"></div>
    </WidgetContainer>
);

export default ContactUsMainAddressWidget;
